var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-dialog',{staticClass:"loadDialog",attrs:{"persistent":"","no-click-animation":true,"value":_vm.loading,"overlay-opacity":"0","width":"95","origin":"center center"}},[_c('Spinner',{staticClass:"spinner"})],1),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }